module.exports = __webpack_public_path__ + "static/img/feature_3.b3a9138.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/feature_3.png
// module id = EWm5
// module chunks = 0